import {createBrowserHistory} from "history";

export const urlLocations = {
    login: "/",
    dashboard: "/dashboard",
    members: "/members",
    member: "/member",
    memberInfo: "/member/:id/:familyID",
    membersPath: "/members/:view?",
    membersTable: "/members/table",
    membersMap: "/members/map",
    family: "/family",
    familyInfo: `/family/:familyID?`,
    liturgies: "/liturgies",
    liturgy: "/liturgy",
    liturgyInfo: "/liturgy/:id?/:action?",
    services: "/services",
    marriageNOC: "/marriage-nocs",
    marriageNOCDetails: "/marriage-noc/:uuid",
    contributions: "/contributions",
    contributionDetails: "/contribution/:id"
};

export const pathBuilder = {
    marriageNOCDetails: uuid => urlLocations.marriageNOCDetails.replace(':uuid', uuid),
    contributionDetails: id => urlLocations.contributionDetails.replace(':id', id),
    memberDetails: member => `${urlLocations.member}/${member?.id}/${member?.familyID}`
}
